import Class from './legacy-class';

import {timeInPast} from '../../../utils/time';
import {escape_html, nl2br} from '../../../utils/string';

var __event_unique_id = 0;

export default Class({
    init: function (options, device_name) {
        this._unique_id = __event_unique_id++;

        this._device_id = options.device_id;
        this._type = options.type || options.event_name;
        this._icon = options.icon || options.event_name;
        this._time = options.time;
        this._x = options.x || (options.gps && options.gps.x);
        this._y = options.y || (options.gps && options.gps.y);
        this._important = !!options.important;

        this._device_name = device_name;

        this._title = options.title || options.type || options.event_name;
        this._details = options.details;
    },

    element: function () {
        return this._element;
    },

    html: function (unread) {
        if (!this._html) this._html = this._generateHtml();

        var klass =
            'ui-event' +
            (unread ? ' unread' : '') +
            (this._important ? ' important' : '');

        return (
            '<div class="' +
            klass +
            '" event-unique-id="' +
            this._unique_id +
            '" event-time="' +
            ~~this._time +
            '">' +
            this._html +
            '</div>'
        );
    },

    icon_url: function () {
        return ZONT_URL.api_event_icon + '?type=' + this._icon;
    },

    _generateHtml: function () {
        return (
            '<img class="ui-event-icon" src="' +
            this.icon_url() +
            '"/>' +
            '<div class="ui-event-device-name">' +
            escape_html(this._device_name || '') +
            '</div>' +
            '<div class="ui-event-time">' +
            timeInPast(new Date(this._time * 1000), {withSeconds: true}) +
            '</div>' +
            '<div class="ui-event-title">' +
            nl2br(escape_html(this._title)) +
            '</div>' +
            (this._details
                ? '<div class="ui-event-details">' +
                  nl2br(escape_html(this._details)) +
                  '</div>'
                : '')
        );
    },

    generateInfoBoxContent: function () {
        return (
            '<div class="ui-event-device-name">' +
            (this._device_name || '') +
            '</div>' +
            (this._time
                ? '<div class="ui-event-time">' +
                  timeInPast(new Date(this._time * 1000), {withSeconds: true}) +
                  '</div>'
                : '') +
            (this._title
                ? '<div class="ui-event-title">' +
                  nl2br(escape_html(this._title)) +
                  '</div>'
                : '') +
            (this._details
                ? '<div class="ui-event-map-details">' + nl2br(this._details) + '</div>'
                : '')
        );
    },
}).implement(
    Class.Properties({
        unique_id: {},
        device_id: {},
        type: {},
        icon: {},
        time: {},
        title: {},
        details: {},
        loc: {
            get: function () {
                if (this._x) return [this._x, this._y];
                else return null;
            },
        },
        device_name: {},
    })
);
